export enum SpicyLevel {
  LIGHT = 'light',
  MEDIUM = 'medium',
  EXTRA = 'extra',
}
